import React, { useState, useEffect } from 'react';
import { Document, Page, pdfjs } from 'react-pdf';
import BrandButton from '../brandButton/BrandButton';

// // This points to /public/pdf.worker.min.mjs in your project
pdfjs.GlobalWorkerOptions.workerSrc = '/pdf.worker.min.mjs';


const PitchDeckViewer = ({ pdfBlob }) => {

    const [numPages, setNumPages] = useState(0);
    const [pageNumber, setPageNumber] = useState(1);
    
  function onDocumentLoadSuccess({ numPages }) {
    setNumPages(numPages);
    setPageNumber(1);
  }

  const changePage = (offset) => {
    setPageNumber(prevPageNumber => prevPageNumber + offset);
  };

  return (
    <div className="flex flex-col max-w-[90vw] md:max-w-xl lg:max-w-3xl xl:max-w-6xl overflow-auto mx-auto">
      <Document
        file={pdfBlob} 
        onLoadSuccess={onDocumentLoadSuccess}
        loading={<div>Loading PDF...</div>}
      >
        {/* We only render the current page to keep performance high */}
        <Page 
          pageNumber={pageNumber} 
          renderAnnotationLayer={false} 
          renderTextLayer={false} // Set to true if you want to allow text selection
        />
      </Document>

      <div className="flex justify-around items-center p-2" style={{ marginTop: '10px' }}>
        <BrandButton
        fontSize="13px"
                  color="#000"
                  bg="#C7DFF0"
                  borderColor="#C7DFF0"
                  text="Previous"
                  w="full"
        maxW="200px" 
          disabled={pageNumber <= 1} 
          onClick={() => changePage(-1)}
        />
        
        <span className='text-sm italics' style={{ margin: '0 15px' }}>
          Page {pageNumber} of {numPages}
        </span>

        <BrandButton 
          disabled={pageNumber >= numPages} 
          onClick={() => changePage(1)}

        fontSize="13px"
                  color="#000"
                  bg="#brand.primary"
                  borderColor="#C7DFF0"
                  text="Next"
                  w="full"
        maxW="200px" 
        />
      </div>
    </div>
  );
};


export default PitchDeckViewer;